'use client'

import { alpha } from '@mui/material/styles'
import { Box, Typography } from '@mui/material'

// Types
import type { CalculatorResultProps } from '@/types/components/molecules/home'

// One result line on the dark panel; the number fades in again whenever it changes
const CalculatorResultMolecule = (props: CalculatorResultProps) => {
	// Props
	const { label, value, unit, total } = props

	return (
		<Box
			sx={{
				py: total ? 3 : 2,
				...(!total && { borderBottom: `1px solid ${alpha('#fff', 0.1)}` }),
				display: 'flex',
				flexDirection: total ? 'column' : 'row',
				alignItems: total ? 'flex-start' : 'baseline',
				justifyContent: 'space-between',
				gap: total ? 1 : 2
			}}
		>
			<Typography sx={{ fontSize: total ? 16 : 15, color: total ? 'common.white' : 'grey.400' }}>{label}</Typography>

			<Typography component="div" sx={{ whiteSpace: 'nowrap', color: total ? 'secondary.light' : 'common.white' }}>
				<Box
					component="span"
					key={value}
					sx={{
						display: 'inline-block',
						'@keyframes resultIn': { from: { opacity: 0.3, translate: '0 6px' }, to: { opacity: 1, translate: '0 0' } },
						animation: 'resultIn .35s ease-out'
					}}
				>
					<Box component="span" sx={{ fontSize: total ? { xs: 36, md: 44 } : 20, fontWeight: 700 }}>
						{value}
					</Box>
				</Box>

				<Box component="span" sx={{ ml: 1, fontSize: total ? 16 : 13, color: total ? 'secondary.light' : 'grey.400' }}>
					{unit}
				</Box>
			</Typography>
		</Box>
	)
}

export default CalculatorResultMolecule
